import {DataModificationsHeader} from 'audit/DataModifications';
import {Permissions} from 'auth/PermissionConstants';
import {UnregisteredBioentity} from 'constants/RegistryConstants';
import * as net from 'util/Net';
import type {BetterJQueryPromise} from 'util/Promises';

export function unregister(
  fileIds: Array<string>,
  folderId: string,
  dataModsHeader?: DataModificationsHeader
): BetterJQueryPromise<{files: Array<UnregisteredBioentity & {permissions: Permissions}>}> {
  return net.postJSON({
    url: '/1/api/registries/actions/remove-files',
    data: {
      fileIds,
      folderId,
    },
    extraHeaders: dataModsHeader,
  });
}

export function create(organizationId: string): JQueryPromise<{}> {
  return net.postJSON({
    url: '/1/api/registries/',
    data: {
      organizationId,
      shouldCreateDefaultSchemas: true,
    },
  });
}

export function deleteRegistry(registryId: string): JQueryPromise<{}> {
  return net.delete_({url: `/1/api/registries/${registryId}`});
}

export function bulkArchive(
  ids: Array<string>,
  purpose: string
): JQueryPromise<{archivedItemIds: Array<string>}> {
  return net.postJSON({
    url: '/1/api/registries:bulk-archive',
    data: {ids, purpose},
  });
}
